import { ConceptNodeMap } from "../../Concepts.interface";

export const isAllChildrenSelected = (
  id: string,
  selected: Set<string>,
  treeMap: ConceptNodeMap,
): boolean => {
  const node = treeMap[id];
  if (!node) return false;

  return node.children.every((child) => {
    return (
      selected.has(child.id) &&
      isAllChildrenSelected(child.id, selected, treeMap)
    );
  });
};
